import { CART_MODULE } from "@/api_framework/api_config";
import { IUrgentCancelAbortResponse, IUrgentCancelSessionPayload } from "@/api_framework/api_modals/Cart";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});

export type IUrgentCancelAbortResult = { status: boolean };

/**
 * Releases an urgent-cancel session and its draft cart. Fired on modal dismiss,
 * so failures stay silent — an orphaned session expires on the backend anyway.
 */
export const useUrgentCancelAbortAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async (payload: IUrgentCancelSessionPayload): Promise<IUrgentCancelAbortResult> => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      const response: IUrgentCancelAbortResult = await axios
        .post(`${CART_MODULE?.URGENT_CANCEL_ABORT?.baseURL}`, payload, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IUrgentCancelAbortResponse>) => ({ status: res.data.status === true }))
        .catch((e: AxiosError) => {
          sendCurl(e.config?.["curlCommand"]);
          captureError(e, false);
          return { status: false };
        });
      return response;
    } catch (e: any) {
      captureError(e);
      return { status: false };
    }
  }, []);

  return { execute };
};
